import "./libs/slick";
import "./libs/infiniteslidev2";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {podcastListSlider} from "./modules/podcastListSlider";
import {featuredVideosSlider} from "./modules/featuredVideosSlider";
import {parallax} from "./modules/parallax";
import {quoteSlider} from "./modules/quoteSlider";
import {ourExpertsSlider} from "./modules/ourExpertsSlider";
import {animationOnScroll} from "./modules/animationOnScroll";
import {countersAnimation} from "./modules/countersAnimation";
import {mobileNav} from "./modules/mobileNav";
import {fullHeightPage} from "./modules/fullHeightPage";
import {stickyHeader} from "./modules/stickyHeader";
import {textAnimation} from "./modules/textAnimation";
import {customSelect} from "./modules/customSelect";
import {blockquoteSlider} from "./modules/blockquoteSlider";
import {popups} from "./modules/popups";
import {copyLinkToBuffer} from "./modules/copyLinkToBuffer";
import {heroVideo} from "./modules/heroVideo";
import {ourSponsorsSlider} from "./modules/ourSponsorsSlider";
import {resetFormFilters} from "./modules/resetFormFilters";


binder({
    bounds: {
        "html": [constants, fullHeightPage],
        ".header": [mobileNav, stickyHeader],
        "select": customSelect,
        ".podcast-list.slider-on-mobile": podcastListSlider,
        ".videos-list.slider": featuredVideosSlider,
        ".has-parallax": parallax,
        ".quote-slider": quoteSlider,
        ".our-experts.slider-on-mobile": ourExpertsSlider,
        ".has-animation": animationOnScroll,
        ".has-counters-animation": countersAnimation,
        ".text-animation": textAnimation,
        ".blockquote-slider": blockquoteSlider,
        ".popup-opener": popups,
        ".copy-link": copyLinkToBuffer,
        ".hero-section": heroVideo,
        ".our-sponsors.has-slider": ourSponsorsSlider,
        ".form-filters": resetFormFilters,
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js